import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { serverError } from './../../../../core/models/messages';
import { ChangeDetectorRef, Component, TemplateRef } from '@angular/core';
import {
  EmptyCV,
  fileTypeExtention,
  obligationSelect,
} from './../../../../core/models/messages';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ISort, translations } from './../../../../core/models/call-offer';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { EsnConsultantService } from './../../../../core/services/esn-consultant/esn-consultant.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../../../core/services/sortdata';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Country, IState, State } from 'country-state-city';
import {
  headerColumns,
  statusCandidate,
} from './../../../../core/models/candidat';
import {
  patternEmail,
  patternNumbersOnly,
  patternfirstName,
} from './../../../../core/models/pattern';
import { EsnCandidatService } from './../../../../core/services/esn-candidat/esn-candidat.service';
import * as JSZip from 'jszip';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, takeUntil } from 'rxjs';
import { CallOfferService } from '@core/services/call-offer-service/call-offer.service';
import { CompanyService } from '@core/services/company/company.service';

@Component({
  selector: 'app-listconsultantclient',
  templateUrl: './listconsultantclient.component.html',
  styleUrls: ['./listconsultantclient.component.css'],
})
export class ListconsultantclientComponent {
  loadSpinner: boolean = false;
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listconsultant: any;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  statut = statusCandidate;
  candidat_id: any;
  fileName: string = '';
  fileError: string = '';
  fileExtention: string = '';
  file: any = '';
  stateList!: IState[];
  showResetButtons: boolean = true;

  isexistemail = false;
  isCollapsed = true;
  cvName: any;
  fileBulkError: any;
  showResetButton: boolean = true;
  idcompany = this.activeroute.snapshot.params['id'];

  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns;
  typeintervenant: any;
  newHeader!: { checked: boolean; name: string; code: string }[];
  displayedColumns: string[] = [
    'select',
    'ID_user',
    'image_url',
    'first_name',
    'phone_number',
    'updated_at',
    'email',
    'city',
    'years_of_experience',
    'CV',
    'score',
    'status',
    'actions',
  ];
  contratRequest = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];

  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  selectedconsultant: any;
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  id: any;
  isButtonDisabled: boolean = false;
  pagination : boolean =false;

  errorMessage: string = '';
  consultantId: any;
  modalRef?: BsModalRef;
  name: any;
  cv: any;
  salary: any;
  idcon!: number;
  consultantExist: boolean = true;
  cv_file!: string;
  Candidate_info: any;
  listclient: { id: number; name: string }[] = [];
  listmanager: { id: number; first_name: string }[] = [];
  manager: any[] = [];
  dataHeader: any = [];
  listNames: string[] = [];
  formconsultant: FormGroup = this.createconsultantForm();
  UpdateForm: FormGroup = this.updateForm();
  listProjects: { id: number; name: string }[] = [];
  esnList: { id: number; name: string }[] = [];

  addBulk!: FormGroup;
  selectedFile: File | null = null;
  client: any[] = [];
  sortAttr: string = '';
  skillsList: { name_FR: string }[] = [];
  first_name: any;
  last_name: any;
  linkedin: any;
  currentSortColumn: string = 'name'; // Initial column to sort by
  clientSelected: boolean = false;
  ischecked = true;
  selectedCandidats: any = [];
  fileExtentions: string = '';
  private unsubscribeAll: Subject<void> = new Subject();
  data: any[] = [
    {
      competences: [
        'nom',
        'prenom',
        'pays',
        'num',
        'email',
        'email_pro',
        'poste',
        'diplomes',
        'certificats',
        'mois_premiere_experience',
        'annee_premiere_experience',
        'client',
        'site_web_client',
        'linkedin_client',
        'date_debut_mission',
        'date_fin_mission',
        'mois_signature_contrat',
        'annee_signature_contrat',
        'salaire',
        'tjm_achat',
        'tjm_vente',
        'linkedin',
        'cv',
        'photo',
        'competences',
      ],
    },
  ];
  constructor(
    private formBuilder: FormBuilder,
    private esnconsultantservice: EsnConsultantService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private modalService: BsModalService,
    private candidatservice: EsnCandidatService,
    private router: Router,
    private appeloffreservice: EsnAppeloffreService,
    private cdRef: ChangeDetectorRef,
    private activeroute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private callofferService: CallOfferService,
    private companyService: CompanyService


  ) {}
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.typeintervenant = 
      this.localStorageService.getData('typeintervenant');

    this.getListclient();
    this.getEsnList();
    this.getListprojet();
    // this.getListmanager();
    console.log('client', this.getListclient());
    // console.log('manager', this.getListmanager());
    this.getListconsultant();
    this.getListSkills();
    this.getListElementHeader();
    this.isButtonDisabled = false;
    this.formconsultant = this.formBuilder.group(
      {
        esn_id: ['', Validators.required],
        candidate_id: [''],
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        email: [
          '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(patternEmail),
          ],
        ],
        emailProESN: ['', [Validators.email, Validators.pattern(patternEmail)]],
        linkedin_link: [''],
        cv: ['', Validators.required],
        desired_workstation: [''],
        date_signature_contrat: [''],
        mission_start_date: [{ value: '', disabled: true }],
        mission_end_date: [{ value: '', disabled: true }],
        salary: ['', [Validators.pattern(patternNumbersOnly)]],
        tjm_achat: ['', [Validators.pattern(patternNumbersOnly)]],
        tjm_vente: ['', [Validators.pattern(patternNumbersOnly)]],
        manager_id: [''],
        client_id: [''],
      },
      { validators: this.dateRangeValidator }
    );

    this.formconsultant = this.createconsultantForm();
    this.formconsultant.get('client_id')?.valueChanges.subscribe((value) => {
      this.clientSelected = !!value;
      if (!this.clientSelected) {
        this.formconsultant.get('mission_start_date')?.disable();
        this.formconsultant.get('mission_end_date')?.disable();
      } else {
        this.formconsultant.get('mission_start_date')?.enable();
        this.formconsultant.get('mission_end_date')?.enable();
      }
    });
  }
  openModalBulk(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.formconsultant.get('open_for_mission')?.setValue(1);
    this.fileExtentions = '';
  }
  /*download file add bulk */
  downloadCsv() {
    const fileSaver = saveAs;
    if (Array.isArray(this.data)) {
      const headers = Object.keys(this.data[0]);
      const csvContent = this.data
        .map((item) => {
          return headers
            .map((header) => {
              if (Array.isArray(item[header])) {
                return item[header].join(';');
              } else if (
                typeof item[header] === 'object' &&
                item[header] !== null
              ) {
                return JSON.stringify(item[header]);
              } else {
                return item[header];
              }
            })
            .join(',');
        })
        .join('\n');

      fileSaver(
        new Blob([csvContent], { type: 'text/csv;charset=utf-8' }),
        'ajout en masse esn consultant.csv'
      );
    } else {
      console.error('Invalid data format. Expected an array.');
    }
  }
  formAddBulk() {
    this.addBulk = this.formBuilder.group({
      file: [null, [Validators.required]],
    });
  }
  fileErr: boolean = false;
  /*select file and add Bulk Candidates */
  onFileSelected(event: any) {
    this.fileErr = false;
    this.fileExtentions = '';
    this.selectedFile = event.target.files[0];

    if (this.selectedFile) {
      console.log('Fichier sélectionné :', this.selectedFile);
      const fileExtension = this.selectedFile.name
        .toLowerCase()
        .substr(this.selectedFile.name.lastIndexOf('.'));
      const allowedExtensions = ['.csv', '.xlsx', '.xls'];
      if (!allowedExtensions.includes(fileExtension)) {
        console.log('selectedFile', fileExtension);
        this.fileExtentions = fileTypeExtention;
        this.fileErr = true;
      }
    }
  }

  addBulkCandidates() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('esn_id', this.idclientConnected);
      this.spinner.show();
      this.esnconsultantservice.addBulkCandidates(formData).subscribe({
        next: (res: any) => {
          this.spinner.hide();

          this.fileBulkError = res.export_file;
          console.log('file bluk error', this.fileBulkError);
          this.getbulkCandidate(this.fileBulkError);
          this.toastrService.success('Fichier importé avec succès');
          this.closeModal();
          this.selectedFile = null;
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error?.message) {
              if (err.error.message === 'File contains only headers.') {
                this.toastrService.error('Le fichier est vide');
              } else if (
                err.error.message ===
                'File headers do not match the expected headers.'
              ) {
                this.toastrService.error(
                  'Les en-têtes de fichiers ne correspondent pas aux en-têtes attendus.'
                );
              } else {
                this.toastrService.error(serverError);
              }
            } else {
              this.toastrService.error(serverError);
            }
            this.closeModal();
            this.selectedFile = null;
          }
        },
      });
    }
  }
  translateCountryName(name: string): string {
    
    return translations[name] || name;
  }
  getbulkCandidate(file: File) {
    let exportSuccess = false;
    this.esnconsultantservice.getbulkCandidate(file).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        const blob = new Blob([res], { type: 'application/octet-stream' });
        saveAs(blob, this.fileBulkError);
        exportSuccess = true;
        if (exportSuccess) {
          this.toastrService.success(
            'Résultat de fichier importé a été exporté avec succès'
          );
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastrService.error(serverError);
      },
    });
  }
  getListElementHeader() {
    if (!this.typeintervenant) {
      this.appeloffreservice
        .getHeaderElements(15)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    } else {
      this.esnconsultantservice
        .listPageconsultantActorIntervenant()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    }
  }

  changeSelectionElement(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    if (!this.typeintervenant) {
      let payload = {
        sub_page_id: data?.id,
      };
      this.appeloffreservice
        .changeDelectedElementHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    } else {
      let payload = {
        sub_page_id: data?.id,
      };
      this.esnconsultantservice
        .changeSubPageStateconsultantIntervenant(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    }
  }

  dateRangeValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const startDate = control.get('mission_start_date')!.value;
    const endDate = control.get('mission_end_date')!.value;

    if (startDate && endDate && startDate > endDate) {
      return { dateRangeInvalid: true };
    }

    return null;
  }

  sortData(item: string) {
    console.log('item', item);
    for (const iterator of headerColumns) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;

    if (this.searchForm.dirty)
      this.listconsultant = this.sortDataService.sortArray(
        this.listconsultant,
        item,
        this.currentSortDirection
      );
    else this.getListconsultant();
  }

  createconsultantForm(data?: any) {
    return this.formBuilder.group(
      {
        first_name: [
          data?.first_name || '',
          [Validators.required, Validators.pattern(patternfirstName)],
        ],
        last_name: [
          data?.last_name || '',
          [Validators.required, Validators.pattern(patternfirstName)],
        ],
        emailProESN: [
          data?.emailProESN || '',
          [Validators.pattern(patternEmail)],
        ],
        email: [
          data?.email || '',
          [Validators.required, Validators.pattern(patternEmail)],
        ],
        linkedin_link: [data?.linkedin_link || ''],
        cv: [data?.cv || ''],
        desired_workstation: [data?.desired_workstation || ''],
        date_signature_contrat: [data?.date_signature_contrat || ''],
        salary: [data?.salary || null],
        tjm_achat: [data?.tjm_achat || ''],
        tjm_vente: [data?.tjm_vente || ''],
        manager_id: [data?.manager_id || null],
        client_id: [data?.client_id || null],
        candidate_id: [data?.candidate_id || ''],
        esn_id: ['', [Validators.required]],
        mission_start_date: [{ value: '', disabled: true }],
        mission_end_date: [{ value: '', disabled: true }],
      },
      { validator: this.dateRangeValidator }
    );
  }

  setValidatorRequirements() {
    if (!this.formconsultant.get('cv')?.value) {
      this.formconsultant
        .get('linkedin_link')
        ?.setValidators([Validators.required]);
      this.formconsultant.get('linkedin_link')!.updateValueAndValidity();
    }
    if (
      !this.formconsultant.get('linkedin_link')?.value ||
      this.formconsultant.get('linkedin_link')?.value == ''
    ) {
      this.formconsultant.get('cv')?.setValidators(Validators.required);
      this.formconsultant.get('cv')!.updateValueAndValidity();
    }
    if (
      this.formconsultant.get('linkedin_link')?.value &&
      this.formconsultant.get('linkedin_link')?.value != ''
    ) {
      this.formconsultant.get('cv')?.clearValidators();
      this.formconsultant.get('cv')!.updateValueAndValidity();
    }
    if (
      this.formconsultant.get('cv')?.value &&
      this.formconsultant.get('cv')?.value != ''
    ) {
      this.formconsultant.get('linkedin_link')?.clearValidators();
      this.formconsultant.get('linkedin_link')!.updateValueAndValidity();
    }
  }
  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (this.ischecked) {
      if (type == 'single' && candidat) {
        if (candidat.cv || candidat.file_test) {
          if (typeFile && typeFile != '')
            candidat.file_test = candidat.file_test.split('/')[1];
          const fileUrl = !typeFile
            ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
            : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
          this.showGlobalSpinner();
          this.candidatservice.downloadPDF(fileUrl).subscribe(
            (data) => {
              const blob = new Blob([data], {
                type: 'application/octet-stream',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = !typeFile
                ? `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_CV.${candidat!.cv.split('.').pop()}`
                : `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_QCM.${candidat!.file_test.split('.').pop()}`;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              this.hideGlobalSpinner();
            },
            () => {
              this.hideGlobalSpinner();
            }
          );
        } else {
          this.toastrService.info(EmptyCV);
        }
      } else if (this.selectedCandidats.length) {
        if (
          this.selectedCandidats.length == 1 &&
          !this.selectedCandidats[0].cv
        ) {
          this.toastrService.info(EmptyCV);
        } else this.downloadPdfFiles(typeFile);
      } else {
        this.toastrService.info(obligationSelect);
      }
    } else {
      this.toastrService.error(
        'Limite de téléchargements atteinte. Vous ne pouvez télécharger que 3 fichiers.'
      );
    }
  }

  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip');
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }

  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }

  getListclient() {
    this.esnconsultantservice.getclient().subscribe({
      next: (response) => {
        if (response.data) {
          this.listclient = response.data;
          this.client = response.data;
        }
      },
      error: (error) => {
        console.error('Error fetching : ', error);
      },
    });
  }

  getListmanager() {
    this.esnconsultantservice.getmanagernew().subscribe({
      next: (response) => {
        if (response.data) {
          this.listmanager = response.data;
          this.manager = response.data;
        }
      },
      error: (error) => {
      },
    });
  }
  clearFile() {
    this.file = null;
    this.fileName = '';
    this.formconsultant.get('cv')?.setValue('');
  }

  createconsultant() {
    this.setValidatorRequirements();
    if (!this.isexistemail) {
      console.log('cv', this.file);
      this.formconsultant.patchValue({
        esn_id: this.idclientConnected,
      });
      console.log('bonjour');
      console.log('this.isexiste', this.isexistemail);

      this.formconsultant.markAllAsTouched();
      this.formconsultant.markAsDirty();
      let fromdata = new FormData();
      fromdata.append('esn_id', this.formconsultant.value.esn_id);
      fromdata.append('first_name', this.formconsultant.value.first_name);
      fromdata.append('last_name', this.formconsultant.value.last_name);
      fromdata.append('email', this.formconsultant.value.email);
      if (this.formconsultant.value.emailProESN) {
        fromdata.append('emailProESN', this.formconsultant.value.emailProESN);
      } else {
        fromdata.append('emailProESN', '');
      }
      fromdata.append(
        'date_signature_contrat',
        this.formconsultant.value.date_signature_contrat
      );
      fromdata.append('linkedin_link', this.formconsultant.value.linkedin_link);
      fromdata.append(
        'desired_workstation',
        this.formconsultant.value.desired_workstation
      );
      fromdata.append('tjm_achat', this.formconsultant.value.tjm_achat);
      fromdata.append('tjm_vente', this.formconsultant.value.tjm_vente);
      fromdata.append('salary', this.formconsultant.value.salary);
      if (this.formconsultant.value.manager_id) {
        fromdata.append('manager_id', this.formconsultant.value.manager_id);
      } else {
        fromdata.append('manager_id', '');
      }
      if (this.formconsultant.value.client_id) {
        fromdata.append('client_id', this.formconsultant.value.client_id);
      } else {
        fromdata.append('client_id', '');
      }
      if (this.file) {
        fromdata.append('cv', this.file);
      } else {
        fromdata.append('cv', '');
      }
      console.log('form', fromdata);
      console.log('form consultant', this.formconsultant.value);
      if (this.formconsultant.invalid) {
        return;
      }

      this.enableFormFields();
      this.esnconsultantservice.createconsultant(fromdata).subscribe({
        next: (response) => {
          console.log('add consultant', response);
          this.toastrService.success('consultant a été ajouté avec succès');
          this.navigateToProfile(response.data.user_id);

          this.getListconsultant();
          this.close_modal_add();
        },
        error: (error: any) => {
          console.error('Error fetching add consultant: ', error);
          if (error?.status === 404) {
            this.toastrService.error('Utilisateur associé à une autre ESN.');
          } else if (error?.error && error?.error?.data) {
            if (
              error.error.data.email &&
              error.error.data.email[0] === 'The email has already been taken.'
            ) {
              this.toastrService.error("L'email est déjà utilisé.");
            } else if (
              error.error.data.linkedin_link &&
              error.error.data.linkedin_link[0] ===
                'The linkedin link must be a valid URL.'
            ) {
              this.toastrService.error(
                'Le lien LinkedIn doit être une URL valide.'
              );
            } else if (
              error.error.data.cv &&
              error.error.data.cv[0] === 'The cv field is required.'
            ) {
              this.toastrService.error('Le CV est requis.');
            } else if (
              error.error.data.linkedin_link &&
              error.error.data.linkedin_link[0] ===
                'The linkedin link has already been taken.'
            ) {
              this.toastrService.error('LinkedIn est déjà utilisé.');
            } else {
              this.toastrService.error("Une erreur inattendue s'est produite.");
            }
          } else {
            this.toastrService.error("Une erreur inattendue s'est produite.");
          }
        },
      });
    } else {
      let data = {
        esn_id: this.idclientConnected,
        candidate_id: this.candidat_id,
        salary: this.formconsultant.value.salary,
        tjm_achat: this.formconsultant.value.tjm_achat,
        tjm_vente: this.formconsultant.value.tjm_vente,
        emailProESN: this.formconsultant.value.emailProESN,
        mission_start_date: this.formconsultant.value.mission_start_date,
        mission_end_date: this.formconsultant.value.mission_end_date,
        manager_id: this.formconsultant.value.manager_id
          ? this.formconsultant.value.manager_id
          : '',
        client_id: this.formconsultant.value.client_id
          ? this.formconsultant.value.client_id
          : '',
        date_signature_contrat:
          this.formconsultant.value.date_signature_contrat,
      };
      this.disableFormFields();
      console.log('data', data);
      this.esnconsultantservice.createconsultant(data).subscribe({
        next: (response) => {
          console.log('add consultant', response);
          this.toastrService.success('consultant a été ajouté avec succès ');

          this.getListconsultant();

          this.close_modal_add();
        },
        error: (error: any) => {
          console.error('Error fetching add consultant: ', error);
          if (error?.status === 404) {
            this.toastrService.error('Utilisateur associé à une autre ESN.');
          } else if (error?.error && error?.error?.data) {
            if (
              error.error.data.email &&
              error.error.data.email[0] === 'The email has already been taken.'
            ) {
              this.toastrService.error("L'email est déjà utilisé.");
            } else if (
              error.error.data.linkedin_link &&
              error.error.data.linkedin_link[0] ===
                'The linkedin link must be a valid URL.'
            ) {
              this.toastrService.error(
                'Le lien LinkedIn doit être une URL valide.'
              );
            } else if (
              error.error.data.cv &&
              error.error.data.cv[0] === 'The cv field is required.'
            ) {
              this.toastrService.error('Le CV est requis.');
            } else if (
              error.error.data.linkedin_link &&
              error.error.data.linkedin_link[0] ===
                'The linkedin link has already been taken.'
            ) {
              this.toastrService.error("L'linkedin est déjà utilisé.");
            } else {
              this.toastrService.error("Une erreur inattendue s'est produite.");
            }
          } else {
            this.toastrService.error("Une erreur inattendue s'est produite.");
          }
        },
      });
    }
  }
  navigateToProfile(consultantId: any) {
    this.router.navigate([
      '/candidats/profilecandidatesn',
      consultantId,
    ]);
  }

  /* set validation for multiple form control */
  setValidations(name: string) {
    this.formconsultant.get(name)?.setValidators(Validators.required);
    this.formconsultant.get(name)!.updateValueAndValidity();
  }
  /* clearValidators */
  clearValidators(name: string) {
    this.formconsultant.get(name)?.clearValidators();
    this.formconsultant.get(name)?.updateValueAndValidity();
  }

  getclientName(manager_id: number): string {
    const manager = this.listmanager.find(
      (manager) => manager.id === manager_id
    );
    return manager ? manager.first_name : 'client not found';
  }

  uploadFile(event: any) {
    this.file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024;
    this.fileName = this.file.name;
    if (this.file) {
      const allowedExtensions = ['.pdf', '.docx', '.doc'];
      const fileExtension = this.file.name
        .toLowerCase()
        .substr(this.file.name.lastIndexOf('.'));

      if (!allowedExtensions.includes(fileExtension)) {
        this.fileExtention = 'Format fichier non compatible !';
      } else if (this.file.size > maxSize) {
        this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
      } else {
        this.fileError = '';
        this.fileExtention = '';
      }
      console.log('file', this.file);
    }
    this.formconsultant.get('cv')?.setValue(this.file);
  }

  isFileNameCompatible(): boolean {
    if (!this.file) {
      return false;
    }

    const allowedExtensions = ['.pdf', '.docx', '.doc'];
    const fileExtension = this.file.name
      .toLowerCase()
      .substr(this.file.name.lastIndexOf('.'));
    return allowedExtensions.includes(fileExtension);
  }

  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchconsultantesn();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListconsultant();
      }
    }
  }
  getListconsultant(sort?: ISort) {
    this.spinner.show();
    let dataPyload =
      this.sortAttr == ''
        ? {
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.esnconsultantservice.getListconsultant(dataPyload).subscribe({
      next: (response: any) => {
        this.spinner.hide();
        if (response.data && response.data.data) {
          console.log('response.data', response.data);
          this.listconsultant = response.data.data
          // .slice(0, this.endIndex);
          console.log('list consultant', this.listconsultant);
          this.formconsultant
            .get('salary')
            ?.setValue(this.listconsultant.consultant_e_s_n_s_Salary);

          this.totalItems = response.data.total;

          console.log('list  consultant esn', this.listconsultant);
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        console.error('Error fetching list  consultant esn: ', error);
      },
    });
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: ['', data?.name],
      post: ['', data?.post],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      manager_name: ['', data?.manager_name],
      client_final_name: ['', data?.client_final_name],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm_vente: ['', data?.tjm_vente],
      tjm_vente_range: ['', data?.tjm_vente_range],
      tjm_achat: ['', data?.tjm_achat],
      tjm_achat_range: ['', data?.tjm_achat_range],
      max_experience_years: ['', data?.max_experience_years],
      min_experience_years: ['', data?.min_experience_years],
      mobility: [[], data?.mobility],
      country: [null, data?.country],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      per_page: this.itemsPerPage,
      page: this.currentPage,
    });
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }

  reset() {
    this.stateList=[];
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchconsultantesn();
  }
  changeSelection(event: any, data: any) {
    data.checked = event.target.checked;
  }
  /* search */
  searchconsultantesn() {
    let valueForm = this.searchForm.value;
    let data = {
      name: valueForm.name,
      post: valueForm.post,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      manager_name: valueForm.manager_name,
      client_final_name: valueForm.client_final_name,
      tjm_achat: valueForm.tjm_achat,
      tjm_achat_range: valueForm.tjm_achat_range,
      tjm_vente: valueForm.tjm_vente,
      tjm_vente_range: valueForm.tjm_vente_range,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      max_experience_years: valueForm.max_experience_years,
      min_experience_years: valueForm.min_experience_years,
      mobility: valueForm.mobility,
      country: valueForm.country,
      per_page: this.itemsPerPage,
      page: this.currentPage,
      search: this.transformSearch(valueForm?.search),
    };
    this.spinner.show();
    this.esnconsultantservice
      .searchconsultant(data)
      .subscribe({
        next: (resSearch) => {
          if (this.currentPage > 1) {
            this.currentPage = 1;
            this.searchconsultantesn();
            this.spinner.hide();
          } else {
            this.listconsultant = resSearch.data.data.slice(0, this.endIndex);
            this.totalItems = resSearch.data.total;
            this.spinner.hide();
          }
        },
        error: (error) => {
          console.log(error);
          this.toastrService.error(serverError);
          this.spinner.hide();
        },
      });
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.searchForm.get('mobility')?.setValue(null);
    }
  }
  ////////////////////////////////////////////////////////////////////////////////////
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }

  getconsultantByEmail(event: any) {
    const enteredEmail = event.target.value.trim();
    console.log('event', enteredEmail);
    let esn_id = this.localStorageService.getData('clientConnected');

    if (enteredEmail === '') {
      this.enableFormFields();
      this.selectedconsultant = '';
      this.formconsultant.patchValue({
        first_name: '',
        last_name: '',
        linkedin_link: '',
        cvName: '',
        desired_workstation: '',
      });
      this.isexistemail = false;
      this.isButtonDisabled = false;
      this.errorMessage = '';
      return;
    }

    this.esnconsultantservice
      .getconsultantbyemail(enteredEmail)
      .subscribe({
        next: (res) => {
          if (res.status === 200) {
            this.isexistemail = true;
            console.log('reponse', res);
            this.selectedconsultant = res.data.cv;
            this.candidat_id = res.data.id;
            if (enteredEmail !== res.data.email) {
              this.formconsultant.patchValue({
                first_name: '',
                last_name: '',
                selectedconsultant: '',
                desired_workstation: '',
              });
              this.isexistemail = false;
              this.isButtonDisabled = false;
              this.errorMessage = '';
              return;
            }

            this.formconsultant.patchValue({
              email: res.data.email,
              first_name: res.data.first_name,
              last_name: res.data.last_name,
              linkedin_link: res.data.linkedin_link,
              selectedconsultant: res.data.cv,
              desired_workstation: res.data.desired_workstation,
            });
            if (res.data.cv) {
              this.file = { name: res.data.cv };
            }
            this.errorMessage = '';
            this.isButtonDisabled = false;

            this.disableFormFields();
          } else {
            this.isexistemail = true;
            this.isButtonDisabled = true;
            this.errorMessage = '"Utilisateur associé à une autre ESN."';
          }
        },
        error: (error: any) => {
          console.log('error', error);
          console.log('message erreur ', error.error.message);
          if (
            error?.error?.message === 'User already associated with this ESN'
          ) {
            this.isexistemail = true;
            this.isButtonDisabled = true;
            this.errorMessage = '"Utilisateur associé à cet ESN."';
          }
          if (error?.error?.message === 'User associated with another ESN') {
            this.isexistemail = true;
            this.isButtonDisabled = true;
            this.errorMessage = '"Utilisateur associé à une autre ESN."';
          }
        },
      });
  }

  resetCV() {
    const inputFile = document.getElementById('cv') as HTMLInputElement;
    if (inputFile) {
      inputFile.value = '';
      this.fileExtention = '';
      this.fileError = '';
    }
    this.fileName = '';
    this.showResetButtons = true;
  }
  disableFormFields() {
    if (this.formconsultant) {
      this.formconsultant.get('first_name')?.disable();
      this.formconsultant.get('last_name')?.disable();

      this.formconsultant.get('linkedin_link')?.disable();

      this.formconsultant.get('cv')?.disable();
    }
  }
  enableFormFields() {
    if (this.formconsultant) {
      this.formconsultant.get('first_name')?.enable();
      this.formconsultant.get('last_name')?.enable();
      this.formconsultant.get('emailProESN')?.enable();
      this.formconsultant.get('linkedin_link')?.enable();
      this.formconsultant.get('desired_workstation')?.enable();
      this.formconsultant.get('cv')?.enable();
    }
  }

  closeModal() {
    this.formconsultant.reset();
    this.selectedconsultant = '';
    this.cvName = '';
    this.isButtonDisabled = false;
    this.errorMessage = '';
    this.modalRef!.hide();
  }
  close_modal_add() {
    console.log('email : ', this.formconsultant.get('email')?.value);
    this.formconsultant.reset();
    this.formconsultant.get('email')?.setValue('');
    this.isButtonDisabled = false;

    this.selectedconsultant = '';
    console.log('selectedconsultant', this.selectedconsultant);
    this.cdRef.detectChanges();
    let btnClose = document.getElementById('ModalClose_add_consultant');

    console.log('btnClose', btnClose);
    if (btnClose) {
      btnClose.click();
      this.formconsultant.reset();
      this.cvName = '';
      this.errorMessage = '';
      this.selectedconsultant = '';
      this.cdRef.detectChanges();
    }

    this.enableFormFields();
    this.isButtonDisabled = false;
    this.errorMessage = '';
    this.selectedconsultant = '';
    this.showResetButtons = false;
    if (this.modalRef && typeof this.modalRef.hide === 'function') {
      this.modalRef.hide();
    }
  }

  resetform() {
    this.formconsultant.reset();
    this.cvName = '';
  }
  isnull: boolean = false;
  // openModal(template: TemplateRef<any>, data?: any, mode?: string) {
  //   console.log('data', data);
  //   if (data.cv === 'null') {
  //     this.isnull = true;
  //   } else {
  //     this.isnull = false;
  //   }

  //   this.formconsultant.get('email')?.setValue('');
  //   this.formconsultant = this.createconsultantForm(data);
  //   console.log('data', this.formconsultant.value);
  //   const salary = this.formconsultant.get('salary');
  //   if (salary && data && data.consultant_e_s_n_s_Salary) {
  //     salary.setValue(data.consultant_e_s_n_s_Salary);
  //   }
  //   const tjm_achat = this.formconsultant.get('tjm_achat');
  //   if (tjm_achat && data && data.consultant_e_s_n_s_Tjm_achat) {
  //     tjm_achat.setValue(data.consultant_e_s_n_s_Tjm_achat);
  //   }
  //   const tjm_vente = this.formconsultant.get('tjm_vente');
  //   if (tjm_vente && data && data.consultant_e_s_n_s_Tjm_vente) {
  //     tjm_vente.setValue(data.consultant_e_s_n_s_Tjm_vente);
  //   }
  //   this.formconsultant.get('client_id')?.setValue(data.client_id);
  //   this.formconsultant.get('manager_id')?.setValue(data.manager_id);
  //   this.formconsultant.get('client_id')?.valueChanges.subscribe((value) => {
  //     this.clientSelected = !!value;
  //     if (!this.clientSelected) {
  //       this.formconsultant.get('mission_start_date')?.disable();
  //       this.formconsultant.get('mission_end_date')?.disable();
  //     } else {
  //       this.formconsultant.get('mission_start_date')?.enable();
  //       this.formconsultant.get('mission_end_date')?.enable();
  //     }
  //   });
  //   this.formconsultant.get('mission_start_date')?.enable();
  //   this.formconsultant.get('mission_end_date')?.enable();
  //   this.formconsultant
  //     .get('date_signature_contrat')
  //     ?.setValue(data.consultant_e_s_n[0].date_signature_contrat);
  //   this.formconsultant
  //     .get('mission_start_date')
  //     ?.setValue(data.consultant_e_s_n_Mission_start_date);
  //   this.formconsultant
  //     .get('mission_end_date')
  //     ?.setValue(data.consultant_e_s_n_Mission_end_date);
  //   this.formconsultant.get('candidate_id')?.setValue(data.id);
  //   this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  // }
  openModaladd(template: TemplateRef<any>, data?: any, mode?: string) {
    this.formconsultant.reset();
    this.formconsultant.get('email')?.setValue('');
    this.selectedconsultant = '';
    this.errorMessage = '';

    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }

  updateConsultant() {
    if (this.formconsultant.value.salary === null) {
      this.formconsultant.value.salary = '';
    }
    this.formconsultant.patchValue({
      tjm_vente: this.formconsultant.value.tjm_vente.toString(),
      tjm_achat: this.formconsultant.value.tjm_achat.toString(),
      salary: this.formconsultant.value.salary.toString(),
    });

    console.log('formconsultant', this.formconsultant);
    this.esnconsultantservice
      .updateConsultant(
        this.formconsultant.value.candidate_id,
        this.formconsultant.value
      )
      .subscribe((res: any) => {
        this.toastrService.success('consultant a été modifié avec succès');
        this.closeModal();
        this.getListconsultant();
      });
  }
  finmission(id: any) {
    Swal.fire({
      title: 'Vous êtes sûr ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui,!',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.esnconsultantservice.finmission(id).subscribe({
          next: (response: any) => {
            console.log('response', response);
            if (response.data) {
              console.log('response.data', response.data);
              this.toastrService.success('Fin mission avec succès.');
              this.getListconsultant();
            }
          },
          error: (error: any) => {
            console.error('Error fetching  appel offre: ', error);
          },
        });
      }
    });
  }
  dissocierconsultant(id: any) {
    console.log('idcandidate', id);
    console.log('idcompany', this.idclientConnected);
    let formdata = new FormData();
    formdata.append('esn_id', this.idclientConnected);
    formdata.append('candidate_id', id);
    console.log('formdata', formdata);
    Swal.fire({
      title: 'Voulez-vous vraiment dissocier ce consultant ? <br> La dissociation entraîne le verrouillage des CRA pour le mois en cours.',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, dissocier !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.esnconsultantservice
          .dissocierconsultant(formdata)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res: any) => {
              console.log('response', res);
              this.getListconsultant();
            },
            error: () => {
              this.spinner.hide();
            },
          });
      }
    });
  }

  /* go to suggestion job offer */
  navigateToSuggestionJobOffer(id: number) {
    this.router.navigate([
      '/consultants/suggestion-jobOffer',
      { id: id },
    ]);
  }

  /* go to suggestion job request */
  navigateToSuggestionJobRequest(id: number) {
    this.router.navigate([
      '/consultants/suggestion-jobRequest',
      { id: id },
    ]);
  }

  redirectToLinkedIn(linkedinLink: string): void {
    window.open(linkedinLink, '_blank');
  }
  isDateRangeValid(): boolean {
    return !this.formconsultant.hasError('dateRangeInvalid');
  }

  updateForm(data?: any) {
    return this.formBuilder.group(
      {
        first_name: [data ? data?.first_name : '', [Validators.required]],
        last_name: [data ? data?.last_name : '', [Validators.required]],
        emailProClient: [
          data ? data?.emailProClient : '',
          [Validators.email, Validators.pattern(patternEmail)],
        ],
        id: [data ? data?.id : ''],
        email: [
          data ? data?.email : '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(patternEmail),
          ],
        ],
        linkedin_link: [data ? data?.linkedin_link : ''],
        date_first_mission: [data ? data?.date_first_mission : ''],
        date_end_mission: [data ? data?.date_end_mission : ''],
        clientFinal_id: [data ? data?.clientFinal_id : ''],
        project_ids: [data ? data?.project_ids : []],
        date_first_service: [data ? data?.date_first_service : ''],
        number_days_of_service: [data ? data?.number_days_of_service : ''],
        poste: [data ? data?.poste : ''],
        esn_id: [data ? data?.esn_id : null],
        tjm_achat: [data ? data?.tjm_achat : ''],
        cv: [data ? data?.cv : ''],
        consultant_client_final_id: [
          data ? data?.consultant_client_final_id : '',
        ],
        user_id: [data ? data?.user_id : []],
      },
      { validator: this.validateDateRange }
    );
  }
  validateDateRange(formGroup: FormGroup): { [key: string]: any } | null {
    const startDate = formGroup.get('date_first_mission')?.value;
    const endDate = formGroup.get('date_end_mission')?.value;

    if (startDate && endDate && startDate > endDate) {
      return {
        dateRangeError:
          'La date de début de mission doit être antérieure à la date de fin de mission.',
      };
    }

    return null;
  }

  getListprojet() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

    this.callofferService.getProjectCompany(this.idclientConnected).subscribe({
      next: (response) => {
        this.listProjects = response.data;
      },
      error: (error) => {
        console.error('Error fetching projet: ', error);
      },
    });
  }
  getEsnList() {
    this.companyService
      .getListEsnClient(this.idclientConnected)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
        
          this.esnList = res.data;
       
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    console.log('data', data);
    this.id = data.id;
    this.UpdateForm = this.updateForm(data);
    this.UpdateForm.get('linkedin_link')?.enable();
    this.enableFormFields();
    const projectNames = data.project_names;
    if (this.UpdateForm.value.project_ids !== null) {
      const selectedProjectIDs = this.listProjects
        .filter((project) => projectNames.includes(project.name))
        .map((project) => project.id);
      this.UpdateForm.get('project_ids')?.setValue(selectedProjectIDs);
    } 
    else {
      this.UpdateForm.get('project_ids')?.setValue([]);
    }
    const selectedEsn = this.esnList
    .filter((project) => data.ESN2.includes(project.name))
    .map((project) => project.id);
    const esnValue = selectedEsn.length === 1 ? selectedEsn[0] : selectedEsn;
    this.UpdateForm.get('esn_id')?.setValue(esnValue);    // this.UpdateForm.get('esn_id')?.setValue(data.ESN2);
    this.UpdateForm.get('tjm_achat')?.setValue(data.Tjm_achat);
    this.UpdateForm.get('date_end_mission')?.setValue(data.Date_end_mission);
    this.UpdateForm.get('date_first_mission')?.setValue(
      data.Date_first_mission
    );
    this.UpdateForm.get('number_days_of_service')?.setValue(
      data.Number_days_of_service
    );
    this.UpdateForm.get('date_first_service')?.setValue(
      data.Date_first_service
    );
    this.UpdateForm.get('user_id')?.setValue(data.id);
    this.UpdateForm.get('consultnat_client_final_id')?.setValue(
      data.consultant_client_final_id
    );
    console.log('update data form', this.UpdateForm.value);
  }
  updateconsultant() {

    if (this.UpdateForm.value.linkedin_link === null) {
      this.UpdateForm.get('linkedin_link')?.setValue('');
    }
    if (this.UpdateForm.value.cv === null) {
      this.UpdateForm.get('cv')?.setValue('');
    }
    if (this.UpdateForm.value.user_id === null) {
      delete this.UpdateForm.value.user_id;
    }
    if (this.UpdateForm.value.emailProClient === null) {
      // delete this.UpdateForm.value.emailProClient
      this.UpdateForm.get('emailProClient')?.setValue('');

    }
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.UpdateForm.get('clientFinal_id')?.setValue(this.idclientConnected);
    this.UpdateForm.get('user_id')?.setValue(this.id);
    if (this.UpdateForm.value.ESN === null) {
      delete this.UpdateForm.value.ESN;
    }

    if (
      this.UpdateForm.value &&
      Array.isArray(this.UpdateForm.value.project_ids)
    ) {
      const project_ids = this.UpdateForm.value.project_ids;
      for (const projectId of project_ids) {
        this.UpdateForm.get('project_ids[]')?.setValue(projectId) ;
      }
    } else {
      console.error("project_ids n'est pas un tableau ou n'est pas défini.");
    }


    console.log('consultant externe', this.UpdateForm.value);
    this.companyService
      .updateconsultant(this.UpdateForm.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.getListconsultant();
          this.toastrService.success(
            'consultant externe  a été modifié avec succès'
          );
          this.closeModal();
          
        },
        error: (err) => {
          console.log('erreuemploy', err);
          this.spinner.hide();

          if (err?.error?.message) {
            if (
              err.error?.message?.emailProClient &&
              err.error?.message?.emailProClient[0] ===
                'The emailProClient has already been taken.'
            ) {
              this.toastrService.error(
                "L'adresse e-mail professionel a déjà été utilisée."
              );
            }
          }
        },
      });
  }

}
